import React from 'react'
import EnterParentPasswordForm from '../Forms/EnterParentPasswordForm';
import { useGlobalState } from '../../contexts/global';

const ModalEnterParentPassword = () => {
    const { state, dispatch } = useGlobalState();
    const callback = state.modalProps.callback;

    return (
        <div className="modal-content">
            <h1 className="h-text-center">Zadejte rodičovské heslo</h1>
            <EnterParentPasswordForm callback={callback} />
        </div>
    );
}

export default ModalEnterParentPassword
